import { useMemo } from 'react';
import { Row, Col, Typography, Space, Divider } from 'antd';
import { CalculationSource, CalculationSummary } from '../types';
import ValueWithDiffError from './ValueWithDiffError';
import { buildTotalsCalculationsDiff } from '../utils';

type Props = {
    localData: CalculationSummary;
    revenueData?: CalculationSummary;
    target: CalculationSource;
};

export default function VatDutySummaryFooter({ localData, revenueData, target }: Props) {
    const diffMap = useMemo(() => {
        if (target === 'revenue' && revenueData) {
            return buildTotalsCalculationsDiff(localData, revenueData);
        }
        return {};
    }, [target, localData, revenueData]);

    const data = target === 'local' ? localData : revenueData;

    if (!data) return null;

    const { totalDuty, totalLiability, totalVat } = data;

    return (
        <div style={{ width: '100%' }}>
            <Row justify="end">
                <Col>
                    <Space direction="vertical" size={12} style={{ minWidth: 260 }}>
                        <Row justify="space-between">
                            <Typography.Text>Total Customs Duties:</Typography.Text>
                            <ValueWithDiffError value={totalDuty} hasError={diffMap.totalDuty} />
                        </Row>

                        <Row justify="space-between">
                            <Typography.Text>Total VAT:</Typography.Text>
                            <ValueWithDiffError value={totalVat} hasError={diffMap.totalVat} />
                        </Row>
                    </Space>
                </Col>
            </Row>

            <Divider style={{ margin: '11px 0' }} />

            <Row justify="end">
                <Col>
                    <div style={{ minWidth: 260 }}>
                        <Row justify="space-between">
                            <Typography.Text>Total Liability:</Typography.Text>
                            <ValueWithDiffError value={totalLiability} hasError={diffMap.totalLiability} />
                        </Row>
                    </div>
                </Col>
            </Row>
        </div>
    );
}
